<script setup lang="ts">
const { allNumbers, data, getMobileNumberStatuses, resetData } =
  useMobileNumberHandler();

const site = useSiteStore();
const { $t } = useNuxtApp();

const emits = defineEmits<{ (e: 'update'): void }>();

const displayAddNumber = computed(() => {
  if (!data.secondaryNumbers) return true;
  return data.secondaryNumbers.length < 1;
});

const deleteNumberHandler = (mobileNumber: string) => {
  clearErrors();
  data.toDelete = mobileNumber;
  site.activateModal('confirmMobileNumberDelete');
};

const clearErrors = () => {
  data.errorRef = '';
  data.errorCode = '';
};

onBeforeMount(async () => {
  await getMobileNumberStatuses();
  data.desiredPrimaryNumber = data.primaryNumber?.mobileNumber;
  clearErrors();
});

watch(
  () => data.numberToVerify?.mobileNumber,
  () => {
    if (!!data.numberToVerify)
      if (!data.numberToVerify?.verified) {
        data.newNumber = data.numberToVerify?.mobileNumber;
      }
  },
);

onUnmounted(() => resetData());
</script>

<template>
  <div
    v-if="allNumbers.length > 0"
    class="pt-2 pb-4 px-4 flex flex-col gap-3 border-t border-light-50 dark:border-dark-600"
  >
    <p class="text-base font-bold mt-4 capitalize">
      {{ $t('account-phone-numbers') }}
    </p>
    <div class="flex flex-col space-y-2">
      <UserProfileManagementMobileNumbersAccountPhoneNumber
        v-for="number in allNumbers"
        :key="number?.mobileNumber"
        :number="number"
        @delete="deleteNumberHandler($event)"
      />
    </div>
    <div v-if="displayAddNumber">
      <UserProfileManagementMobileNumbersAddNumber
        @clear-errors="clearErrors"
        @update="emits('update')"
      />
    </div>
  </div>
  <UserInterfaceGenericError
    v-if="data.errorCode"
    state="danger"
    class="max-w-72 mx-auto mb-2"
    :reference-code="data.errorRef"
  >
    {{ $t(`update-details-${data.errorCode}`) }}
  </UserInterfaceGenericError>
</template>
